import React from "react";

const PaginationBar = ({
  totalRecords = 0,
  indexOfFirstRow = 0,
  indexOfLastRow = 0,
  currentPage = 1,
  totalPages = 1,
  gotoPage = () => {},
  maxPagesToShow = 5,
}) => {
  if (!totalRecords) return null;

  return (
    <div className="pagination mt-4 flex items-center justify-between">
      <span>
        Showing {indexOfFirstRow + 1} to {indexOfLastRow} of {totalRecords} entries
      </span>

      <div className="pagination-controls flex items-center gap-2">
        <button
          disabled={currentPage === 1}
          onClick={() => gotoPage(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Previous
        </button>

        {(() => {
          const pageButtons = [];
          const maxPages = Math.max(1, Number(maxPagesToShow) || 5);

          let startPage = Math.max(1, currentPage - Math.floor(maxPages / 2));
          let endPage = startPage + maxPages - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxPages + 1);
          }

          if (startPage > 1) {
            pageButtons.push(1);
            if (startPage > 2) pageButtons.push("...");
          }

          for (let i = startPage; i <= endPage; i++) {
            pageButtons.push(i);
          }

          if (endPage < totalPages) {
            if (endPage < totalPages - 1) pageButtons.push("...");
            pageButtons.push(totalPages);
          }

          return pageButtons.map((p, idx) =>
            p === "..." ? (
              <span key={idx} className="px-2 text-gray-500">
                ...
              </span>
            ) : (
              <button
                key={idx}
                onClick={() => gotoPage(p)}
                className={`px-3 py-1 border rounded ${currentPage === p ? "bg-blue-500 text-white" : ""}`}
              >
                {p}
              </button>
            )
          );
        })()}

        <button
          disabled={currentPage === totalPages}
          onClick={() => gotoPage(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationBar;
